import { getUrlParameter, initDefaultSelect2, makeKTBlock, makeSwal } from '../../general/functions';
import { BASE_URL } from '../../general/variables';
import { initTimePicker } from './function';
import { $repeater, createInvoiceValidation, invoiceList } from './setup';

const initGlobalScript = (eventType) => {
  const hash = window.location.hash;
  if (hash) {
    // Bootstrap 4 tab activation
    const $tabTrigger = $(`[data-toggle="tab"][href="${hash}"], [data-toggle="tab"][data-target="${hash}"]`);
    if ($tabTrigger.length) {
      $tabTrigger.tab('show');
    }
  }

  if ($('.select2-no-search').length) {
    initDefaultSelect2(false, null, '.select2-no-search', undefined, 'Choose...');
  }

  setTimeout(() => {
    $.post(
      BASE_URL + 'C_Event/getEndorserList',
      {
        id: $('input[name="formID"]').val(),
      },
      function (resp) {
        let parseJson = JSON.parse(resp);
        let indStats = [];

        if (parseJson != null) {
          // Tembak masing-masing data ke dalam Form Repeater
          $.each(parseJson, function (index, value) {
            indStats.push({
              kolName: value.ENDORSE_NAME,
              kolLink: value.ENDORSE_SHORTLINK,
              kolClick: value.HIT,
              kolRegister: value.REGISTERED,
              kolID: value.ENDORSE_ID,
            });
          });
          // Masukin data ke Form Repeater
          $repeater.setList(indStats);
        } else {
          // Kalau pertama kali, masukin data kosong ke Form Repeater
          indStats.setList({
            kolName: '',
            kolLink: '',
            kolClick: '',
            kolRegister: '',
            kolID: '',
          });
        }
      }
    );
  }, 1500);

  $('#btnSaveDetail').on('click', function (e) {
    e.preventDefault();
    $(this).attr('disabled', true);
    $('#formInfoDetails').submit();
  });

  $('#formInfoDetails').on('submit', function (e) {
    e.preventDefault();

    let action = $(this).attr('action'),
      method = $(this).attr('method'),
      form = $(this)[0],
      formData = new FormData(form);

    let eventFormID = $('input[name="eventID"]').val();
    let cityMap = $(`input[name="radioCityMap"]`);

    if (cityMap.is(':checked') && !eventFormID) {
      $('#btnSaveDetail').attr('disabled', false);
      makeSwal('Oops! Something’s missing', '<strong>City Mapping</strong> cannot be created or updated while the <strong>ID Event</strong> is empty.', 'warning');
      return;
    }

    $.ajax({
      url: action,
      type: method,
      data: formData,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      xhr: function () {
        var xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener(
          'progress',
          function (evt) {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total;
              let progressPercent = Math.round(percentComplete * 100);
              $('#btnSaveDetail').text(`Please wait... (${progressPercent}%)`);
            }
          },
          false
        );
        return xhr;
      },
      success: function (response) {
        const { status, header, message } = response;
        Swal.fire({
          title: header,
          text: message,
          icon: status,
          allowOutsideClick: false,
        }).then((result) => {
          $('#btnSaveDetail').attr('disabled', false);
          if (result.isConfirmed) {
            location.reload();
          }
        });
      },
      error: function (data) {
        Swal.fire({
          title: data.statusText,
          html: data.responseText,
          icon: 'error',
        });
        setTimeout(() => {
          $('#btnSaveDetail').prop('disabled', false);
          $('#btnSaveDetail').text(`Save`);
        }, 500);
      },
    });
  });

  let $repeaterRundown = $('#repeaterRundown').repeater({
    initEmpty: true,
    ready: function () {
      initTimePicker('.event-rundown-starttime');
    },
    show: function (element) {
      initTimePicker('.event-rundown-starttime');
      $(this).slideDown();
    },
    hide: function (deleteElement) {
      $(this).slideUp(deleteElement);
    },
  });

  const setRepeaterDataRundown = (response) => {
    if (response.length) {
      $repeaterRundown.setList(response);
    }
  };

  let isAdditionalDetails = $('#isAdditionalDetails').val();
  if (isAdditionalDetails) {
    let parsingDt = JSON.parse(isAdditionalDetails);
    if (parsingDt.rundown) {
      setRepeaterDataRundown(parsingDt.rundown);
    }
  }

  // Mulai proses submit data ke Backend
  $(document).on('click', '.btn-delete-invoice', function () {
    let curValue = $(this);
    Swal.fire({
      title: 'Delete current payment',
      html: 'Are you sure you want to delete this payment? This process <strong>cannot be reversed</strong>!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Close',
    }).then((result) => {
      if (result.value) {
        $.post(
          `${BASE_URL}C_Event/deletePayment`,
          {
            id: curValue.attr('data-id'),
            eid: getUrlParameter('id'),
          },
          function (resp) {
            if (resp.code == 200) {
              Swal.fire({
                title: 'Payment Removed',
                html: 'Payment has been removed succesfully',
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'Close',
              }).then((res) => {
                invoiceList.reload();
              });
            } else {
              Swal.fire({
                title: 'Process Failed',
                html: 'Payment cannot be removed, please try again later',
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'Close',
              });
            }
          }
        );
      }
    });
  });
  // End Script Listener

  $('#btnCreateInvoice').on('click', function () {
    makeKTBlock('#addCreateInvoice .modal-dialog');

    createInvoiceValidation.validate().then(function (status) {
      if (status == 'Valid') {
        let action = $('#formCreateInvoice').attr('action'),
          formData = new FormData($('#formCreateInvoice')[0]);

        $.ajax({
          url: action, // your backend URL
          type: 'POST',
          data: formData,
          dataType: 'JSON',
          processData: false, // prevent jQuery from converting data
          contentType: false, // prevent jQuery from overriding content type
          success: function (response) {
            makeKTBlock('#addCreateInvoice .modal-dialog', 'hide');
            const { header, message, status } = response;
            makeSwal(header, message, status);

            $('#addCreateInvoice').modal('hide');
            invoiceList.reload();
          },
          error: function (xhr, status, error) {
            makeKTBlock('#addCreateInvoice .modal-dialog', 'hide');
            console.error('Create invoice failed:', error);
          },
        });
      } else {
        makeKTBlock('#addCreateInvoice .modal-dialog', 'hide');
      }
    });
  });

  $('#addCreateInvoice').on('hidden.bs.modal', function () {
    $(this).find('form')[0].reset();
    $(this).find('select').val('').trigger('change');
    $(this).find('input[type=file]').val('');
    $('#createInvoiceDetails').summernote('reset');
  });

  $('#eventBudget, #eventDescription').summernote({
    focus: true,
    height: 250,
    placeholder: 'Add additional notes here . . .',
  });

  $('#formEditPayment').on('submit', function (e) {
    e.preventDefault();

    makeKTBlock('#editPaymentModal .modal-dialog');
    let action = $(this).attr('action'),
      formData = new FormData(this);

    $.ajax({
      url: action, // your backend URL
      type: 'POST',
      data: formData,
      dataType: 'JSON',
      processData: false, // prevent jQuery from converting data
      contentType: false, // prevent jQuery from overriding content type
      success: function (response) {
        makeKTBlock('#editPaymentModal .modal-dialog', 'hide');
        const { header, message, status } = response;
        makeSwal(header, message, status);

        $('#editPaymentModal').modal('hide');
        invoiceList.reload();
      },
      error: function (xhr, status, error) {
        makeKTBlock('#editPaymentModal .modal-dialog', 'hide');
        console.error('Update failed:', error);
      },
    });
  });
};

export { initGlobalScript };
